export default "__VITE_PUBLIC_ASSET__fc746674__"